import { useAppStatus } from 'features/appStatus/hooks/useAppStatus';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { useCobrand } from 'features/cobrand/hooks/useCobrandUtils';
import { useLoggedInUser } from 'features/auth/hooks/useAuthData';
import { getBrowserInfo, getDeviceType } from 'utils/deviceInfoUtils';
import {
  useCreateDeleteAccountRequestMutation,
  useCreateSupportRequestMutation,
} from 'services/supportService';
import { prepareDeleteAccountRequest, prepareHelpRequest } from '../utils';

// Tickets go through the backend so Zendesk doesn't hold them in the suspended queue as anonymous requests.
export const useZendesk = () => {
  const { version } = useAppStatus();
  const { translation } = useTranslationContext();
  const { cobrand } = useCobrand();
  const user = useLoggedInUser();
  const [createSupportRequest] = useCreateSupportRequestMutation();
  const [createDeleteAccountRequest] = useCreateDeleteAccountRequestMutation();
  const appName = cobrand.displayName;
  const { browserType, browserVersion } = getBrowserInfo();
  const deviceType = getDeviceType();
  const fileOboardingHelpTicket = (request: SignUpHelpData) =>
    createSupportRequest(
      prepareHelpRequest({
        ...request,
        appName,
        appNameWithVersion: `${appName} web (${version})`,
        language: translation('zendesk_language_name'),
        deviceType,
        browserType,
        browserVersion,
      }),
    ).unwrap();

  const fileDeleteAccountRequest = (request: { name: string }) =>
    createDeleteAccountRequest({
      memberUuid: user?.uuid ?? '',
      body: prepareDeleteAccountRequest({
        name: request.name,
        appName,
        appNameWithVersion: `${appName} web (${version})`,
        language: translation('zendesk_language_name'),
        deviceType,
        browserType,
        browserVersion,
      }),
    }).unwrap();

  return { fileOboardingHelpTicket, fileDeleteAccountRequest };
};
